// Don't reorder, must match 0..11 to Jan..Dec
const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

/**
 * e.g. "1 May 21", "21 Sep 98"
 *
 * This is used on some hot paths of our application. Please don't
 * refactor without measuring the performance impact.
 */
export function shortDateFormat(date: Readonly<Date>) {
  const year = date.getFullYear().toString();
  const twoDigitYear = year.slice(-2);
  const month = MONTHS[date.getMonth()];
  return `${date.getDate()} ${month} ${twoDigitYear}`;
}

export function timeFormat(date: Date) {
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}

/**
 * Convert unix milliseconds to Date
 */
export function msToDate(milliseconds: number): Date {
  return new Date(milliseconds);
}
